import { queryString, } from '../../jsCore/utils/window';
import { t } from '../../jsCore/providers/i18nProvider/i18nProvider';
import {TYPES} from '../../jsCore/organizedByType/actions/actionCounterProviderActions';
import { warn, } from '../../jsCore/application/console';


const { communityFeatured: communityFeaturedQuery } = queryString;
const { DATA_RECEIVED, RECEIVED_ERROR, } = TYPES;
const DOMAINS = ['90min', '12up', 'ftb90', 'dbltap' ];
const I18N_BASE_PATH = 'post_page.community_disclaimer';
const INITIAL_STATE = {
  isFeatured: false,
  communityDisclaimerI18nKeysByDomain: DOMAINS
    .reduce((i18nDefaultKeysObject, domain) => (
      { ...i18nDefaultKeysObject, [domain]: '' }
    ), {}),
};


function toNumber(string) {
  return string === undefined ? undefined : parseInt(string, 10);
}

function shouldShowDisclaimer(communityFeaturedQuery, featured) {
  return toNumber(communityFeaturedQuery) || toNumber(featured) ? false : true;
}

const isFeatured = shouldShowDisclaimer.part(communityFeaturedQuery);

function getI18nKeysByDomains(domains, basePath) {
  return domains.reduce((i18nKeysObject, domain) => {
    return { ...i18nKeysObject, [domain]: t(`${basePath}_${domain}`), };
  }, {});
}

const getI18nKeys = getI18nKeysByDomains.part(DOMAINS, I18N_BASE_PATH);

function setStateDataRecived(state, action) {
  const { featured, } = action.state;
  return {
    isFeatured: isFeatured(featured),
    communityDisclaimerI18nKeysByDomain: getI18nKeys(),
  };
}

function setStateDataError(state, action) {
  const { error } = action.state;
  warn('Error recieving data from external source, check with provier', { error, action, });
  return {
    isFeatured: isFeatured(undefined),
    communityDisclaimerI18nKeysByDomain: getI18nKeys(),
  };
}

function setState(state, newState){
  return { ...state, ...newState };
}

export function communityDisclaimerReducer(state = INITIAL_STATE, action){
  switch (action.type) {
    case DATA_RECEIVED:
      return setState(state, setStateDataRecived(state, action));
    case RECEIVED_ERROR:
      return setState(state, setStateDataError(state, action));
    default:
      return setState(state, action.state);
  }
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/community_disclaimer/communityDisclaimerReducer.js